import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { UserRoles } from '../../shared/constants';
import LoadingSpinner from '../Shared/LoadingSpinner';
import { isNull } from 'lodash';

import {
  getFacilityRoleById,
  getPharmacyNameFromToken,
  getPrivilegeById,
} from '../../shared/utils';
import { Helmet } from 'react-helmet';
import logo from '../../images/omcareBigLogo.png';
import { lightTeal } from '../../mainTheme';
import CustomerCareDashboard from './CustomerCareDashboard';
import { getDashboardUser } from '../../store/dashboardUser/actionCreators';

const stateSelector = (state: RootState) => {
  const { dashboardUser } = state;
  const { dashboardUserInfo } = dashboardUser;

  return {
    dashboardUserInfo,
    isLoading: dashboardUser.isLoading,
  };
};

const HomePage = () => {
  const dispatch = useDispatch();
  const { dashboardUserInfo, isLoading } = useSelector(stateSelector);

  useEffect(() => {
    if (isNull(dashboardUserInfo)) {
      dispatch(getDashboardUser());
    }
  }, [dashboardUserInfo, dispatch]);

  if (isLoading || isNull(dashboardUserInfo)) {
    return <LoadingSpinner />;
  }

  // Check for user role to determine which dashboard to show ( right now only customer care dashboard exists / Facility admin dashboard removes since new UI comesout)
  const userRole = dashboardUserInfo.facility_role_id
    ? (getFacilityRoleById(dashboardUserInfo.facility_role_id) as UserRoles)
    : (getPrivilegeById(dashboardUserInfo?.privilege_id ?? 0) as UserRoles);

  if (
    userRole === UserRoles.CUSTOMER_CARE ||
    userRole === UserRoles.FACILITY_ADMIN
  ) {
    return <CustomerCareDashboard />;
  }

  if (userRole === UserRoles.PHARMACY_TECH) {
    return (
      <div style={{ textAlign: 'center' }}>
        <Helmet>
          <title>Ōmcare - Pharmacy portal</title>
        </Helmet>
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p
            style={{
              marginTop: '24px',
              fontSize: '16px',
              fontWeight: 500,
              letterSpacing: '2px',
              textTransform: 'uppercase',
              color: lightTeal,
            }}
          >
            Pharmacy portal
          </p>
          <p style={{ fontSize: '28px', fontWeight: 700, margin: 0 }}>
            {dashboardUserInfo.pharmacy_name ||
              getPharmacyNameFromToken() ||
              'Pharmacy'}
          </p>
        </header>
      </div>
    );
  }

  if (
    // Temporary restrict screen for non-facility users
    isNull(dashboardUserInfo.facility_name) ||
    (dashboardUserInfo.facility_name &&
      !['Facility admin', 'Scheduler'].includes(
        getFacilityRoleById(dashboardUserInfo.facility_role_id ?? 0),
      ))
  ) {
    return (
      <div style={{ textAlign: 'center' }}>
        <Helmet>
          <title>Ōmcare - Dashboard</title>
        </Helmet>
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
        </header>
      </div>
    );
  }
  return null;
};

export default HomePage;
